// extracted by mini-css-extract-plugin
module.exports = {"dashedLine":"ProductInformation_dashedLine__12BfU"};